import type { PropsWithChildren, ReactNode } from "react";

import Link from "next/link";

import { isExternal } from "@/src/app/externalLinks";

type TypoLinkProps = PropsWithChildren<{
  readonly darkBackground?: boolean;
  readonly href: string;
}>;

export function TypoLink({
  children,
  darkBackground = false,
  href,
}: TypoLinkProps): ReactNode {
  return isExternal(href) ? (
    <a className={darkBackground ? "link-on-dark-bg" : "link"} href={href}>
      {children}
    </a>
  ) : (
    <Link className={darkBackground ? "link-on-dark-bg" : "link"} href={href}>
      {children}
    </Link>
  );
}
